// extracted by mini-css-extract-plugin
module.exports = {"link":"style-module__link___fP6Dk"};